import React from 'react';

const IconRevert = () => (
  <svg xmlns="http://www.w3.org/2000/svg">
    <g id="Exploded_Icons" data-name="Exploded Icons">
      <path
        id="_Compound_Path_"
        data-name="<Compound Path>"
        fill="var(--primary-color)"
        d="M75.26,38.68A17,17,0,0,0,64,42.91l-5.86-5.86V51.7H72.81l-5.89-5.89A13,13,0,0,1,87.63,51.7l3.86-1.27A17.12,17.12,0,0,0,75.26,38.68Z"></path>
    </g>
  </svg>
);

export default IconRevert;
